import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { CalAngularService } from '@cvx/cal-angular';
import config from '../assets/config.json';

@Injectable({
    providedIn: 'root'
})
export class GraphService {
    constructor(
        private http: HttpClient,
        private calService: CalAngularService
    ) { }
    
    // Gets access token for Microsoft Graph API calls
    public async getAccessToken(): Promise<string | null> {
        try {
            const token = await lastValueFrom(this.calService.getAADToken(['User.Read', 'User.Read.All']));
            if (typeof token === 'string') {
                return token;
            } else if (token && typeof token === 'object' && 'accessToken' in token) {
                return token.accessToken;
            }
            return null;
        } catch (error) {
            console.error('Error getting access token:', error);
            return null;
        }
    }

    public async getApiAccessToken(): Promise<string | null> {
        try {
            const graphscopeUrl = (config as any).graphscopeUrl;
            const token = await lastValueFrom(this.calService.getAADToken([ `${graphscopeUrl}/user_impersonation`]));
            if (typeof token === 'string') {
                return token;
            } else if (token && typeof token === 'object' && 'accessToken' in token) {
                return token.accessToken;
            }
            return null;
        } catch (error) {
            console.error('Error getting access token:', error);
            return null;
        }
    }
    
    // Fetches the user's profile photo from Microsoft Graph
    public async getUserPhoto(): Promise<string | ArrayBuffer | null> {
        const p = new Promise<string | ArrayBuffer | null>((resolve, reject) => {
            let photo: string | ArrayBuffer | null = "x";
            try {
                this.getAccessToken().then((accessToken) => {
                    if (!accessToken) {
                        reject('No access token available');
                        return;
                    }
                    
                    let url = "https://graph.microsoft.com/v1.0/me/photo/$value"
                    let headers: HttpHeaders = new HttpHeaders({
                        Authorization: `Bearer ${accessToken}`
                    });
                    let stream$ = this.http.get(url, { headers: headers, responseType: "blob" });
                    if (stream$) {
                        lastValueFrom(stream$).then((response: Blob) => {
                            if (response) {
                                let reader: FileReader = new FileReader();
                                reader.readAsDataURL(response);
                                reader.onloadend = () => {
                                    photo = reader.result;
                                    resolve(photo);
                                }
                            }
                        }).catch(reject);
                    }
                }).catch(reject);
            } catch (error) {
                reject(error);
            }
        });
        return await p;
    }
}
